import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { authGuard } from './guards/auth.guard';
import { Shell } from '@app/shell';
import { HomeComponent } from '@shell/components/home/home.component';
import { ShellComponent } from '@shell/shell.component';
import { NoAccessErrorComponent } from '@shell/errors/no-access-error/no-access-error.component';
import { InvalidPathErrorComponent } from '@shell/errors/invalid-path-error/invalid-path-error.component';
import { CYComponent } from '@modules/cy/pages/cy/cy.component';
import {PatientHomeComponent} from '@shell/components/patient-home/patient-home.component';
import {environment} from '@env/environment';
import {PatientMenuComponent} from '@modules/cy/patient/ps/pages/patient-menu/patient-menu.component';
import {PROJECTS} from '@core/constants';
import {PatientSummaryComponent} from '@modules/cy/patient/ps/pages/patient-summary/patient-summary.component';
import {physicianGuard} from '@app/auth/guards/physician.guard';
import {CreateEditRoutes} from '@modules/cy/patient/ps/create-edit/create-edit-routing.module';
import {EprescriptionComponent} from '@modules/cy/patient/ep/pages/eprescription/eprescription.component';
import {OrcdComponent} from '@modules/cy/patient/orcd/pages/orcd/orcd.component';
import {SupportComponent} from 'ncp-lib';


const project = environment.project;

const routes: Routes = [
  Shell.childRoutes([
    {
      path: '',
      component: environment.project === PROJECTS.PROVIDERS ? HomeComponent : PatientHomeComponent,
      data: {},
      //pathMatch: 'full',
      children: [
        ...environment.project === PROJECTS.BENEFICIARIES ? [
          {
            path: '',
            component: PatientMenuComponent,
          },
          {
            path: 'ps',
            component: PatientSummaryComponent,
          },
          {
            path: 'ep',
            component: EprescriptionComponent,
          },
          {
            path: 'orcd',
            component: OrcdComponent,
          },
        ] : []
      ]
    },
    {
      path: 'logout',
      component: LogoutComponent,
    },
    {
      path: 'support',
      component: SupportComponent
    },
    {
      path: 'noaccess',
      component: NoAccessErrorComponent,
    },
    {
      path: 'invalidpath',
      component: InvalidPathErrorComponent,
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
